<template>
  <section id="products">
    <v-row class="ma-10 pt-10" align="center" justify="center">
      <h1 style="font-size: xx-large;">{{ translate('product_1') }}</h1>
      <v-col cols="12" md="9">
        <v-slide-group v-model="selectedItem" class="pa-4" selected-class="bg-success" height="430" next-icon="mdi-chevron-right">
          <template v-slot:next>
            <div class="ml-10">
              <img src="@/assets/syxpay/next_arrow.png">
            </div>
          </template>
          <template v-slot:prev>
            <div class="mr-10">
              <img src="@/assets/syxpay/prev_arrow.png">
            </div>
          </template>
          <v-row align="center" class="mt-2 mb-2" justify="space-around">
            <v-slide-group-item v-for="(feature, i) in features" :key="i">
              <v-col class="text-center">
                <v-card style="border-style: solid; border-color: #61BB46; border-width: 2px;"
                  class="width-card card rounded-xl"
                  height="400">
                  <v-container style="height:170px; width:170px;">
                    <v-img :src="feature.img" class="d-block ml-auto mr-auto" cover></v-img>
                  </v-container>
                  <p style="font-weight: 600; font-size: 24px;">{{ feature.title }}</p>
                  <p style="text-align: center; font-size: 14px;" class="px-6 font-weight-regular">
                    {{ feature.text }}
                  </p>
                </v-card>
              </v-col>
            </v-slide-group-item>
          </v-row>
        </v-slide-group>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  props: ['translate'],
  data() {
    return {
      dialog: false,
      model: null,
      selectedItem: null,
    };
  },
  computed: {
    features() {
      return [
        {
          img: require("@/assets/syxpay/finance_planner.png"),
          title: "FINANCIAL PLANNER",
          text: this.translate('product_financial'),
        },
        {
          img: require("@/assets/syxpay/ppob.png"),
          title: "PPOB",
          text: this.translate('product_ppob'),
        },
        {
          img: require("@/assets/syxpay/my_bizz.png"),
          title: "MY BIZZ",
          text: this.translate('product_my_bizz'),
        },
        {
          img: require("@/assets/syxpay/transfer.png"),
          title: "TRANSFER",
          text: this.translate('product_transfer'),
        },
        {
          img: require("@/assets/syxpay/e_education.png"),
          title: "E-EDUCATION",
          text: this.translate('product_education'),
        },
      ];
    }
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,700,900');

#products {
  margin: 0 !important;
}

.width-card {
  width: 290px;
}
@media (max-width: 600px) {
  .width-card {
    width: 250px;
  }
}

</style>